import React, { Suspense } from 'react';
import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import { ApolloProvider } from '@apollo/react-hooks';
import i18n from './i18n';
import apolloClient from './apollo/apolloClient';
import AssignmentCreate from './components/Assignment/AssignmentCreate';
import { StudentSubmissionProvider } from './components/AssignmentSubmissionEvaluate/StudentSubmissionPageContext';
import { AssignmentAttachmentContextProvider } from './components/AssignmentSubmission/AssignmentAttachmentContext';
import ErrorHandler from './components/common/ErrorHandler/ErrorHandler';
import assignmentTypes from './utils/assignmentTypes';
import AssignmentClassDashboardPage from './pages/AssignmentClassDashboardPage';
import AssignmentCreatePage from './pages/AssignmentCreatePage';
import AssignmentEditPage from './pages/AssignmentEditPage';
import AssignmentSubmissionEvaluatePage from './pages/AssignmentSubmissionEvaluatePage';
import AssignmentSubmissionPage from './pages/AssignmentSubmissionPage';
import Spinner from './components/common/Spinner/Spinner';
import withLaunchDarkly from './utils/launchDarklyWrapper';

function App() {
  return (
    <Suspense fallback={<Spinner isCentered={true} />}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={{ dir: 'ltr', lang: 'ENGLISH', langCode: 'en' }}>
          <ApolloProvider client={apolloClient}>
            <Router>
              <ErrorHandler>
                <Switch>
                  <Route exact path="/" component={AssignmentCreate} />
                  <Route
                    exact
                    path="/assignment/create"
                    component={AssignmentCreatePage}
                  />
                  <Route
                    exact
                    path="/assignment/:assignmentInstanceId/edit"
                    component={AssignmentEditPage}
                  />
                  <Route
                    exact
                    path="/assignment/:assignmentId/assignmentInstance/:assignmentInstanceId/student/:studentId"
                    render={routeProps => (
                      <AssignmentSubmissionPage
                        assignmentType={assignmentTypes.TEACHER}
                        {...routeProps}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/assignment/:assignmentId/student/:studentId"
                    render={routeProps => (
                      <AssignmentSubmissionPage
                        assignmentType={assignmentTypes.ALEF}
                        {...routeProps}
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/assignmentInstance/:assignmentInstanceId/classDashboard"
                  >
                    <AssignmentClassDashboardPage
                      assignmentType={assignmentTypes.TEACHER}
                    />
                  </Route>
                  <Route exact path="/assignment/:assignmentId/classDashboard">
                    <AssignmentClassDashboardPage
                      assignmentType={assignmentTypes.ALEF}
                    />
                  </Route>
                  <Route
                    path={`/assignmentInstance/:assignmentInstanceId/evaluate/:studentId`}
                  >
                    <StudentSubmissionProvider>
                      <AssignmentAttachmentContextProvider>
                        <AssignmentSubmissionEvaluatePage
                          assignmentType={assignmentTypes.TEACHER}
                        />
                      </AssignmentAttachmentContextProvider>
                    </StudentSubmissionProvider>
                  </Route>
                  <Route
                    exact
                    path="/assignment/:assignmentId/evaluate/:studentId"
                  >
                    <StudentSubmissionProvider>
                      <AssignmentAttachmentContextProvider>
                        <AssignmentSubmissionEvaluatePage
                          assignmentType={assignmentTypes.ALEF}
                        />
                      </AssignmentAttachmentContextProvider>
                    </StudentSubmissionProvider>
                  </Route>
                  <Redirect from="*" to="/" />
                </Switch>
              </ErrorHandler>
            </Router>
          </ApolloProvider>
        </ThemeProvider>
      </I18nextProvider>
    </Suspense>
  );
}

export default withLaunchDarkly(App);
